export default function () {
  return {
    items: [],
    isLoading: false,
    activeSubMenuName: null,
  };
}
